export const hallymGangnamReceiptHtml = `
<!DOCTYPE html>
<html lang="en">

  <head>
    <title>진료비 영수증</title>
  </head>
  <body>
     <div class="receipt-wrap hallymGangnam">
      <div class="table1">
        <table>
          <tr>
            <td class="main-title-td" >
              <div class="doc-meta-wrap" >
                <span name="" class="doc-meta-item1"></span>
                <span name="ctr_nm" class="doc-meta-item2"></span>
               </div>
              <div class="main-title-wrap">
                <ul>
                  <li><span name="receipt_nm"></span> 진료비 계산서ㆍ영수증</li>

                </ul>
              </div>
              <div class="pt-num-wrap" >
                <span name="pt_no"></span>
                <span name="sub_pt_gb" ></span>
               </div>
            </td>
          </tr>
          <tr>
            <td>
              <table class="patient-info">
                    <colgroup>
                        <col style="width:300px;"/>
                        <col style="width:300px;"/>
                        <col/>
                        <col/>
                        <col style="width:240px;"/>
                    </colgroup>
                    <tr>
                        <td class="line2-t line2-r">환자등록번호</td>
                        <td class="line2-t line2-r">환자성명</td>
                        <td  class="line2-t  line-r"colspan="2">진료기간</td>
                        <td class="line2-t">야간(공휴일)진료</td>
                    </tr>
                    <tr>
                        <td class="line-t line2-r"><span class="pt_no" name="pt_no"></span></td>
                        <td class="line-t line2-r"><span class="pt_nm" name="pt_nm"></span></td>
                        <td class="line-t line-r" colspan="2">
                        <div class="period-wrap">
                            <span class="data-box" name="med_str_dt"></span>
                            <p class="start-date">부터</p>
                            <span class="data-box" name="med_end_dt"></span>
                            <p class="end-date">까지</p>
                        </div>
                        </td>
                        <td class="line-t">
                            <div class="checkbox-wrap">
                                <div>
                                <span class="squre-box-small" name="night_yn"></span>
                                <span>야간</span>
                                </div>
                                <div>
                                <span class="squre-box-small" name="holiday_yn"></span>
                                <span>공휴일</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="line2-t line2-r">진료과목</td>
                        <td class="line2-t line2-r">질병군(DRG)번호</td>
                        <td class="line2-t line-r">병실</td>
                        <td class="line2-t line-r">환자구분</td>
                        <td  class="line2-t">영수증번호(연월-일련번호)</td>
                    </tr>
                    <tr>
                        <td class="line-t line2-r">
                            <span name="dept_nm"></span>
                            <span name="medr_nm"></span>
                        </td>
                        <td class="line-t line2-r"><span name="disease_cd"></span></td>
                        <td class="line-t line-r"><span name="ward_room"></span></td>
                        <td class="line-t line-r"><span name="pt_gb"></span></td>
                        <td  class="line-t" style="width: 33px !important">
                            <span name="receipt_id"></span>
                        </td>
                    </tr>
                </table>
            </td>
          </tr>

          <tr>
            <td  class="">
              <div class="row-div">
                <div>

                  <table style="table-layout:fixed" class="medical-info ">
                    <colgroup>
                      <col style="width:30px;">
                      <col style="width:75px;">
                      <col style="width:85px;">
                      <col >
                      <col >
                      <col >
                      <col >

                      <col style="width:70px;">
                      <col style="width:70px;">
                      <col style="width:100px;">
                    </colgroup>
                    <tr class="">
                      <td colspan="3" rowspan="3" class="line2-t line-r">항목</td>
                      <td colspan="3"  class="line2-t line-r">급여</td>
                      <td rowspan="3" class="line2-t line2-r" >비급여</td>
                      <td colspan="3" class="tit-red line2-t">금액산정내역</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="line-t line-r">일부 본인부담</td>
                      <td rowspan="2" style="width:132px;text-align: center;" class="line-r line-t">전액<br>본인부담</td>
                      <td colspan="2" rowspan="2" class="line2-t line-r tit-red">⑥진료비 총액<br/>(①+②+③+④)</td>
                      <td colspan="" rowspan="2" class="line2-t  tit-red"><span name="total_price"></span></td>
                    </tr>
                    <tr>
                      <td style="width:100px;" class="line-t">본인부담금</td>
                      <td style="width:100px;" class="line-t line-r">공담부담금</td>
                    </tr>
                    <tbody name="receipt_items">
                      <tr class="">
                        <td rowspan="18" style="width:20px;" class="txt-bold line2-t line2-r">
                          기<br/>본<br/>항<br/>목
                        </td>
                        <td colspan="2" class="line2-t line-r" >진찰료</td>

                        <td class="line2-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td  class="line2-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line2-t line-r ">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-t line2-r">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" rowspan="2"  class="line2-t line-r tit-red">
                             ⑦공단부담 총액<br />
                            (②+⑤)
                        </td>
                        <td rowspan="2" class="line2-t  tit-red ">
                            <span name="total_insurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="3" class="line-t line-r">입원료</td>
                        <td class="line-t line-r">1인실</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="small-gap  line-r line-t">2ㆍ3인실</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" rowspan="2" class="line-t line-r tit-red">
                             ⑧환자부담 총액<br />
                        (①-⑤)+③+④)
                        </td>
                        <td rowspan="2" class="line-t tit-red" >
                           <span
                          name="total_partial_patient_responsibility_price"
                        ></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="small-gap line-t line-r">4인실이상</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">식대</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" rowspan="2" class="line-r line-t tit-red">
                             ⑨이미 납부한 금액
                        </td>
                        <td rowspan="2" class="line-t tit-red">
                           <span name="already_paid_price"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2" class="line-r line-t">투약 및<br/>조제료</td>
                        <td class="line-t line-r">행위료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>

                      </tr>
                      <tr>
                        <td class="line-t line-r">약품비</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" rowspan="2" class="line2-t tit-red">
                               ⑩납부할 금액<br />
                        (⑧-⑨)
                        </td>
                        <td rowspan="2" class="line2-t line-l tit-red">
                           <span name="price_to_be_paid"></span>
                        </td>
                      </tr>
                      <tr>
                        <td rowspan="2" class="line-t line-r">주사료</td>
                        <td class="line-t line-r">행위료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>

                      </tr>
                      <tr>
                        <td class="line-t line-r">약품비</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2"class="line2-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line2-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">마취료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2"class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">처치 및 수술료</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">검사료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">영상진단료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="letter-small line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-r line-t">방사선치료료</td>

                        <td  class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-r line-t">치료재료대</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">재활 및 물리치료료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">정신요법로</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-r line-t tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="small-gap line-t line-r">전혈 및 혈액성분제제료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr class="">
                        <td rowspan="6" class="txt-bold line2-r line2-t">선<br/>택<br/>항<br/>목</td>
                        <td colspan="2" class="line2-t line-r">CT 진단료</td>

                        <td class="line2-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-t line2-r">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line2-t line-r tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line2-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-r line-t">MRI 진단료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-r line-t tit-red"><span name="additional_items item_nm"></span></td>
                        <td class="line-t tit-red"><span name="additional_items item_value"></span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">PET 진단료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td rowspan="4" class="line2-t line2-r tit-red">⑪납부<br />한 금액</td>
                        <td class="line2-t line-r tit-red">카드</td>
                        <td class="line2-t tit-red">
                            <span name="price_paid_card"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">초음파 진단료</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td class="line-t line-r tit-red letter-small">현금영수증</td>
                        <td class="line-t tit-red">
                            <span name="price_paid_cash_receipt"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="line-t line-r">보철ㆍ교정료</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                         <td class="line-t line-r tit-red">현금</td>
                        <td class="line-t tit-red">
                             <span name="price_paid_cash"></span>
                        </td>
                      </tr>
                      <tr class="">
                        <td colspan="2" class="line-r line-t">제증명수수료</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td class="line-t line-r tit-red">합계</td>
                        <td class="line-t tit-red">
                            <span name="price_paid_total"></span>
                        </td>
                      </tr>
                      <tr>
                        <td class="line2-t line-r" colspan="3">선별급여</td>

                        <td class="line2-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-t line2-r">
                          <span name="uninsurance_price"></span>
                        </td>
                         <td colspan="2" class="letter-small line2-t line-r tit-red">납부 하지 않은 금액(⑩-⑪)</td>
                      </td>
                      <td class="line2-t tit-red"></td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line2-t line-r">65세 이상 등 정액</td>

                        <td class="line2-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line2-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-t line2-r">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="3" class="line2-t">
                        현금영수증(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                      </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line-t line-r">정액수가(요양병원)</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r">신분확인번호</td>
                        <td class="line-t">
                            <span name="cash_receipt_id_number"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line-t line-r">정액수가(완화의료)</td>

                        <td class="line-t line-r">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                         <td colspan="2" class="line-t line-r">현금영수증 승인번호</td>
                        <td class="line-t">
                            <span name="cash_receipt_approval_number"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line-t line-r">질병군 포괄수가</td>

                        <td class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r"></td>
                        <td class="line-t"></td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line-r line-t">기타</td>
                         <td  class="line-r line-t">
                          <span
                            name="partial_patient_responsibility_price"
                          ></span>
                        </td>
                        <td class="line-r line-t">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                       <td colspan="2" class="line-t line-r"></td>
                        <td class="line-t"></td>
                      </tr>
                      <tr>
                        <td colspan="3" class="line-t line-r">소계</td>
                        <td class="line-t line-r">
                          <span name="partial_patient_responsibility_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="insurance_price"></span>
                        </td>
                        <td class="line-t line-r">
                          <span name="full_patient_responsibility_price"></span>
                        </td>
                        <td class="line2-r line-t">
                          <span name="uninsurance_price"></span>
                        </td>
                        <td colspan="2" class="line-t line-r"></td>
                        <td class="line-t"></td>
                      </tr>

                      <tr class="">
                        <td colspan="3" class="line2-t line-r">합계</td>
                        <td class="line2-t line-r">
                          <div class="prefix-wrap">
                            <span>①</span>
                            <span
                              name="partial_patient_responsibility_price"
                            ></span>
                          </div>
                        </td>
                        <td class="line2-t line-r">
                          <div class="prefix-wrap">
                            <span>②</span>
                            <span name="insurance_price"></span>
                          </div>
                        </td>
                        <td class="line2-t line-r">
                          <div class="prefix-wrap">
                            <span>③</span>
                            <span
                              name="full_patient_responsibility_price"
                            ></span>
                          </div>
                        </td>
                        <td class="line2-t line2-r">
                          <div class="prefix-wrap">
                            <span>④</span>
                            <span name="uninsurance_price"></span>
                          </div>
                        </td>
                         <td colspan="2" class="line2-t line-r">합계</td>
                         <td class="txt-black line2-t"">
                            <span name="price_paid_total"></span> </td>
                      </tr>
                      <tr class="">
                        <td colspan="3" class="line2-t line-r">상한액 초과금</td>
                        <td class="line2-t line-r">
                          <div class="prefix-wrap">
                            <span>⑤</span>
                            <span name="over_limit_price"></span>
                          </div>
                        </td>
                        <td class="line2-t line-r"></td>
                        <td class="line2-t line-r"></td>
                        <td class="line2-t line2-r"></td>
                        <td colspan="2" class="line2-t line-r">승인번호</td>
                        <td class="txt-black line2-t">
                           <span name="approval_number" class="ft-size-10"></span>
                        </td>
                      </tr>
                      <tr class="">
                        <td colspan="7" class="txt-black line2-t  line2-r">카드매출전표(승인)</td>
                        <td colspan="2" class="line2-t line-r">가맹점번호</td>
                        <td class="txt-black line2-t">
                          <span name="business_registration_number" class="ft-size-10"></span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7" class="txt-black line2-r line-t">
                          <div class="in-list">
                            <ul>
                              <li><span>카드종류</span><span name="card_company"></span></li>
                              <li><span>카드번호</span><span name="card_number"></span></li>
                            </ul>
                          </div>
                        </td>
                        <td colspan="2" class="line-r line-t">할부기간</td>
                        <td class="txt-black line-t">
                            <span name="installment_month"></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="">
              <div>
                <table class="footer-info">
                  <tr class="">
                    <td style="width: 135px" class="line2-t line-r">요양기관 종류</td>
                    <td colspan="5"  class="line2-t">
                      <div class="row-between">

                        <div class="checkbox-wrap align-left">
                          <span class="squre-box-small"></span>
                          <span>의원급ㆍ보건기관</span>
                        </div>

                        <div class="checkbox-wrap align-left">
                          <span class="squre-box-small"></span>
                          <span>병원급</span>
                        </div>

                        <div class="checkbox-wrap align-left">
                          <span class="squre-box-small check"></span>
                          <span>종합병원</span>
                        </div>

                        <div class="checkbox-wrap align-left">
                          <span class="squre-box-small"></span>
                          <span>상급종합병원</span>
                        </div>

                      </div>
                    </td>
                  </tr>
                  <tr class="bg-skyblue">
                    <td style="width: 100px" class="line2-t line-r">사업자등록번호</td>
                    <td class="txt-bold line2-t line-r"><span>118-82-00457</span></td>
                    <td style="width: 80px" class="line2-t line-r">상호</td>
                    <td  class="txt-bold line2-t line-r"><span>한림대학교강남성심병원</span></td>
                    <td class="line2-t line-r">전화번호</td>
                    <td class="txt-bold line2-t">
                      <span>1577-5587</span>
                    </td>
                  </tr>
                 <tr class="bg-skyblue">
                    <td class="line-r line-t">사업장 소재지</td>
                    <td colspan="3" class="line-t line-r">
                      <span>서울시 영등포구 신길로 1</span>
                    </td>
                    <td style="width: 100px" class="line-t line-r">
                      대표자
                    </td>
                    <td class="line-t">
                      <span name="rpst_nm"></span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" class="line-t">발행일 <span name="">
                    <span style="color: #333;" name="issue_datetime_year"></span>년 <span style="color: #333;" name="issue_datetime_month"></span>월 <span style="color: #333;" name="issue_datetime_date"></span>일</span></td>
                  </tr>
                </table>
                <div class="footer-info-bottom">
                  <ul class="list">
                    <li>
                      <ul>
                        <li>수납자 : <span name="payee_name"></span></li>
                        <li>수납일시 : <span name="payment_dtm"></span></li>

                        <li>위 금액을 정히 영수함.</li>
                      </ul>
                      <div class="info-bottom">
                        <div class="left">
                          <div style="font-size:10px;">※ 본원 영수증에 대한 일반사항 및 항목별 설명은 뒷면 참조하시기 바랍니다.</div>
                          <div>
                            <span style="font-size:12px;">http://www.hallym.or.kr</span> <span style="font-size:16px;">콜센터 1577-5587</span>
                          </div>
                        </div>
                        <div class="right official-seal"><span style="font-size:18px;">한림대학교강남성심병원<span style="font-size:18px;">(인)</span></span></div>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table2">
        <div class="table2-wrap">
          <table>
            <colgroup>
              <col style="width:75px;"/>
              <col style="width:*"/>
              <col style="width:50px"/>
            <col style="width:*"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="td-title bg-skyblue" colspan="4"><span>진료예약증</span></td>
              </tr>
              <tr>
                <td colspan="4">
                  <div class="guide-section">
                    <ul>
                      <li><p>
                      진료문의, 예약 및 변경은<br/> 
                      <span class="txt-red">1577-5587</span> 로 하시고, <br/>2번을 누르세요.
                      </p>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="line-t line-r td-label">등록번호</td>
                <td class="line-t line-r td-content"><span name="pt_no"></span></td>
                <td class="line-t line-r td-label">성명</td>
                <td class="line-t td-content"><span name="pt_nm"></span></td>
              </tr>
              <tr>
                <td colspan="4" class="line-t">
                  <div style="height:250px; display: flex; flex-direction: column;" name="med_rsv">
                  </div>
                </td>
              </tr>
              <tr>
                <td class="line-t" colspan="4">
                <ul class="table-footer">
                  <li>콜센터 : 1577-5587 </li>
                  <li>
                    <div class="day">
                      <span name="med_rsv_dt_year"></span>년<span name="med_rsv_dt_month"></span>월<span name="med_rsv_dt_date"></span>일
                    </div>
                  </li>
                  <li>http://www.hallym.or.kr</li>
                  <li>한림대학교강남성심병원</li>
                </ul>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table2-2wrap">
          <table>
            <tbody>
              <tr>
                <td class="td-title bg-skyblue" style="height:32px;"><span>안내사항</span></td>
              </tr>
              <tr>
                <td class="line-t">
                    <div class="info-section">
                      <div class="info-content">
                        <div name="additional_content_title"></div>
                        <div name="additional_content_value"></div>
                      </div>
                      <div class="footer-slogan">
                        <div>
                       <span name="campaign"></span>
                        </div>
                        <div class="line-box">
                          진료문의, 예약 및 변경은 <span class="txt-red">1577-5587</span>로 하시고 2번을 누르세요
                        </div>
                      </div>
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
       <div class="table3">
        <div class="table3-wrap">
          <table class="barcode-info">
            <colgroup>
              <col style=""/>
              <col style="width:50px"/>
              <col style="width:50px"/>
              <col style=""/>
            </colgroup>
            <tbody>
             <tr>
                <td class="td-title" colspan="4"><span>귀하께서 가셔야 할 곳</span></td>
              </tr>
              <tr>
                <td class="line-t line-r">등록번호</td>
                <td class="line-t line-r">성명</td>
                <td class="line-t line-r">일자</td>
                <td class="line-t">진료과</td>
              </tr>
              <tr>
                <td class="line-t line-r td-content"><span name="pt_no"></span></td>
                <td class="line-t line-r td-content"><span name="pt_nm"></span></td>
                <td class="line-t line-r td-content"><span name="place_to_go_dt"></span></td>
                <td class="line-t td-content">
                  <div class="align-columns">
                    <span name="dept_nm"></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="line2-t line-r">층</td>
                <td class="line2-t line-r" colspan="3">장소</td>
              </tr>
              <tr>
                <td colspan="4" class="line-t" style="vertical-align:top;">
                <div  style="min-height: 280px;display: flex;flex-direction: column;justify-content: space-between;">
                  <div name="place_to_go"></div>
                  <div style="" class="barcode-box">
                      <div class="barcode-wrap">
                        <svg class="parking-barcode" id="receipt-barcode-1" alt="barcode" preserveAspectRatio="none"></svg>
                    </div>
                  </div>
                </div>
                 
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table3-2wrap">
          <table>
            <colgroup>
              <col style="width:40%;"/>
              <col style="width:60%"/>
            </colgroup>
            <tbody>
              <tr>
                <td class="td-title line-r"><span>약교환권</span></td>
                <td><span name="drug_voucher_drug_cd"></span></td>
              </tr>
              <tr>
                <td colspan="2" class="line-t">
                  <div class="info-footer">
                    <span class="txt-red">자동접수</span>되오니 전광판에 번호가 켜지면 <span class="txt-red">약교환권</span>을 제출하시기 바랍니다.
                  </div>
                </td>
              </tr>
              <tr>
                <td class="line2-t line-r tb-label">등록번호/성명</td>
                <td class="line2-t td-content"><span name="drug_voucher_pt_info"></span></td>
              </tr>
              <tr>
                <td class="line-t line-r tb-label">진료과목/성별/나이</td>
                <td class="line-t td-content"><span name="drug_voucher_dept_info"></span></td>
              </tr>
              <tr>
                <td class="line-t line-r tb-label">일자/시간</td>
                <td class="line-t td-content"><span name="drug_voucher_op_dtm"></span></td>
              </tr>
              <tr>
                 <td class="td-title line-t line-r"><span>원외처방전</span></td>
                 <td class="line-t align-left text-box"><span class="txt-red">외부약국</span>에서 약을 구입하시기 바랍니다</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table3-3wrap">
          <svg class="parking-barcode" id="receipt-barcode-2" alt="barcode" preserveAspectRatio="none"></svg>
          <div style="min-height: 300px;" name="prk_guide"></div>
        </div>
      </div>
    </div>
  </body>
</html>
`;
